module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10046.9547b3be.jpg";